import { render, staticRenderFns } from "./OrderSent.vue?vue&type=template&id=6c308d27&"
import script from "./OrderSent.vue?vue&type=script&lang=js&"
export * from "./OrderSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports